import * as React from 'react';
import { DropdownList } from 'react-widgets';
import { FilterProps } from './types';

function dropdownFilter<T extends Record<string, unknown>>(
    data: SelectObject[],
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    containerClassName?: string,
): React.FunctionComponent<FilterProps<T>> {
    return React.memo(({ column: { filterValue, setFilter } }: FilterProps<T>) => {
        // `0` is a real option value (e.g. Datasheet "Not required"), so only "All" — an empty value —
        // may clear the filter; a truthiness check dropped `0` and left the column unfiltered.
        const isEmpty = (value: SelectObject['value']) => value === undefined || value === null || value === '';

        // `undefined` (not `''`) so react-table drops the filter for "All" whatever the column's
        // filter type is — `''` survives an `equals` column and would go to the API as `key=`.
        const handleChange = (item: SelectObject) => {
            setFilter(isEmpty(item.value) ? undefined : item.value);
        };

        return (
            <DropdownList
                containerClassName={containerClassName}
                data={[{ label: 'All', value: '' }, ...data]}
                textField="label"
                valueField="value"
                onChange={handleChange}
                value={isEmpty(filterValue) ? undefined : filterValue}
            />
        );
    });
}

export default dropdownFilter;
